<footer class="footer bg-light py-5">
  <div class="container">
    <div class="row">
      <!-- Logo y descripción -->
      <div class="col-lg-4 mb-4 mb-lg-0">
        <h2 class="h4 fw-bold text-primary">PEGAESPUMAS</h2>
        <p class="mt-3">
          Líderes en soluciones innovadoras de espuma de poliuretano con más de 20 años de
          experiencia en el mercado.
        </p>
      </div>

      <!-- Enlaces rápidos -->
      <div class="col-lg-2 mb-4 mb-lg-0">
        <h5 class="fw-bold mb-3">Enlaces Rápidos</h5>
        <ul class="list-unstyled">
          <li class="mb-2"><a href="#" class="text-decoration-none">Inicio</a></li>
          <li class="mb-2"><a href="#historia" class="text-decoration-none">Sobre Nosotros</a></li>
          <li class="mb-2"><a href="#Productos" class="text-decoration-none">Productos</a></li>
          <li class="mb-2"><a href="#clientes" class="text-decoration-none">Clientes</a></li>
          <li class="mb-2"><a href="#contacto" class="text-decoration-none">Contacto</a></li>
        </ul>
      </div>

      <!-- Medios de pago -->
      <div class="col-lg-4 mb-4 mb-lg-0">
        <h5 class="fw-bold mb-3">MEDIOS DE PAGO</h5>
        <div class="d-flex flex-wrap gap-3">
          <div class="payment-icon">
            <i class="fab fa-cc-mastercard fa-2x text-dark"></i>
            <span class="d-block small mt-1">Mastercard</span>
          </div>
          <div class="payment-icon">
            <i class="fab fa-cc-visa fa-2x text-primary"></i>
            <span class="d-block small mt-1">Visa</span>
          </div>
          <div class="payment-icon">
            <i class="fas fa-mobile-alt fa-2x text-info"></i>
            <span class="d-block small mt-1">Nequi</span>
          </div>
          <div class="payment-icon">
            <i class="fas fa-wallet fa-2x text-success"></i>
            <span class="d-block small mt-1">Daviplata</span>
          </div>
          <div class="payment-icon">
            <i class="fas fa-credit-card fa-2x text-secondary"></i>
            <span class="d-block small mt-1">Tarjeta Codensa</span>
          </div>
          <div class="payment-icon">
            <i class="fas fa-money-bill-wave fa-2x text-success"></i>
            <span class="d-block small mt-1">Efectivo</span>
          </div>
        </div>
      </div>

      <!-- Contacto -->
      <div class="col-lg-2">
        <h5 class="fw-bold mb-3">Contacto</h5>
        <address class="mb-3">
          <li style="list-style: none">
            <a
              href="https://wa.me/573118384439"
              target="_blank"
              rel="noopener noreferrer"
              style="text-decoration: none; color: #131514"
            >
              <i class="bi-whatsapp" style="font-size: 1rem"></i> Escríbenos
            </a>
          </li>

          <a href="#contacto" style="text-decoration: none; color: #131514">
            <i class="fas fa-map-marker-alt me-2"></i>
            Cra 25 # 67-39, Bogotá
          </a>
          <a href="tel:+573118384439" style="text-decoration: none; color: #131514">
            <i class="fas fa-phone me-2"></i> +57 3118384439
          </a>
        </address>
        <a href="mailto:info@espumasinnovadoras.com" style="text-decoration: none; color: #131514">
          <i class="fas fa-envelope me-2"></i>pegaespumas1@gmail.com
        </a>
      </div>
    </div>

    <hr class="my-4" />

    <!-- Copyright -->
    <div class="row align-items-center">
      <div class="col-md-6">
        <p class="mb-0">© 2026 PEGAESPUMAS. Todos los derechos reservados.</p>
      </div>
      <div class="col-md-6 text-md-end">
        <p class="mb-0">Diseñado por RAGDE39</p>
      </div>
    </div>
  </div>
</footer>
